<template>
  <header class="legal-brand-strip legal-header" role="banner">
    <div class="legal-header-inner">
      <router-link :to="{ name: 'login' }" class="legal-logo-lockup" aria-label="CuraScript — home">
        <img src="@/assets/styles/img/logo-small.svg" alt="" class="legal-logo-img" />
      </router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: 'LegalPageHeader',
};
</script>
